<template>
  <v-container fluid>
    <Window
      v-model="record_id"
      name="Verbale MRV"
      ref="window"
    ></Window>
    <br />
    <v-flex d-flex>
      <v-btn text :disabled="!record_id" @click="downloadVerbale"
        ><v-icon>mdi-download</v-icon>Download Verbale</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn text color="error" @click="close">Chiudi</v-btn>
    </v-flex>
  </v-container>
</template>

<script>
/*eslint-disable */
import Window from "../components/Window.vue";
export default {
  components: { Window },
  data() {
    return {
      record_id: 0,
    };
  },
  methods: {
    close() {
      this.$router.push({ path: "/" });
    },
    downloadVerbale() {
      console.log("downloadVerbale");
      this.$store.commit("setProgressMessage", "Download in corso");
      this.$store.commit("setProgressLoading", true);
      let parameters = {};
      parameters.idempiereRestPath = "print/addPrintJob";
      let data = {};
      data.parameters = "{id:" + this.record_id + "}";
      data.nomeStampa = "Verbale MRV";
      parameters.data = data;
      this.$store.dispatch("callIdempiereRest", parameters).then((response) => {
        if (response.data.hasOwnProperty("file")) {
          const linkSource =
            "data:application/pdf;base64," + response.data.file;
          const downloadLink = document.createElement("a");
          const fileName = "verbale.pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.$store.commit("setProgressMessage", null);
        } else {
          this.$store.commit("setProgressMessage", null);
          var errorMsg = "Download non riuscito";
          if (response.data.hasOwnProperty("message")) {
            errorMsg = errorMsg + "\n" + response.data.message;
          }
          this.$store.commit("setErrorMessage", errorMsg);
        }
      });
    },
  },
  mounted() {
    let datiVerbale = this.$store.state.datiVerbale;
    this.record_id = datiVerbale.fct_vermrv_id;
    setTimeout(() => {
      this.$refs.window.setValue("C_BPartner_ID", datiVerbale.c_bpartner_id);
      this.$refs.window.setValue(
        "fct_scadverifiche_ID",
        datiVerbale.fct_scadverifiche_id
      );
    }, 1000);
  },
};
</script>

<style>
</style>